module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"coach_mark_message":"向上滑动查看 <br /> <b>更多评价</b>","coach_mark_message_pc":"滚动鼠标或使用键盘方向键 ⬆️⬇️<br />可查看<b>更多评价</b>","see_more_reviews":"浏览评价"}}')
  delete Component.options._Ctor
}
